import { DeviceFactory } from './deviceFactory';

import type { DeviceEntity, DeviceProps } from './deviceEntity';
import type { DeviceIRepository } from './deviceIRepository';
import type { EntityDataType } from '@/infra/appsync';
import type { DeviceJson } from '@/types/domain/device/entities/deviceEntity';

import { AppsyncRepositoryPvt } from '@/domain/appsyncRepositoryPvt';
import {
  EntityName,
} from '@/infra/appsync';

export class DeviceRepository extends AppsyncRepositoryPvt<
  DeviceEntity,
  DeviceProps,
  DeviceJson
> implements DeviceIRepository {
  private factory = new DeviceFactory();

  protected get entityName(): EntityName {
    return EntityName.WagakoAppDeviceDeviceEntity;
  }

  protected createFromEntityDataType = (
    props: EntityDataType,
  ) => this.factory.createFromEntityDataType(props);
}
